import type { FAQCategory } from "@tfg/db"

import { i18n } from "~/i18n.ts"

export const FAQ_CATEGORIES: { [key in FAQCategory]: string } = {
  DASHBOARD: i18n.t("categories.dashboard", { ns: "faq" }),
  PRODUCTS: i18n.t("categories.products", { ns: "faq" }),
  SUPPLIERS: i18n.t("categories.suppliers", { ns: "faq" }),
  CERTIFICATES: i18n.t("categories.certificates", { ns: "faq" }),
  DATA_TRANSFER: i18n.t("categories.dataTransfer", { ns: "faq" }),
  OTHER: i18n.t("categories.other", { ns: "faq" }),
} as const
